import React from "react"
import Cabecalho from "../Cabecalho"
import { PainelRoteirizacao } from "./components/PainelRoteirizacao"

export function Roteirizacao() {
    return (
        <>
            <Cabecalho pagina="Roteirização" />
            <PainelRoteirizacao />
        </>
    )
}
